import React, {memo, useContext, useState} from 'react';
import './CashOutPopUp.scss';
import {useTranslation} from "react-i18next";
import {CASH_OUT_DATA} from "../../../services/RequestDatas";
import RequestManager from "../../../services/RequestManager";
import Utils from "../../../utils/Utils";
import {AppContext} from "../../../App";

function CashOutPopUp({cashOutData, hideCashOutPopUp}) {
  const {t} = useTranslation();
  const context = useContext(AppContext);

  const currency = cashOutData['currency'];
  const totalCashOut = cashOutData['total_partial_cashout_amount'];
  const socket = RequestManager.getInstance().webSocket;
  const [warning, setWarning] = useState(null);

  const sendCashOutRequest = () => {
    const data = CASH_OUT_DATA;
    data.params.bet_id = cashOutData['id'];
    data.params.price = cashOutData['amount'];

    socket.send(JSON.stringify(data));
    socket.addEventListener(RequestManager.CASH_OUT_EVENT, response => handleCashOut(response.detail), {once: true});
  }

  const handleCashOut = response => {
    const data = response.data;

    if (data.result === 'Ok') {
      setWarning(null);
      hideCashOutPopUp();
    } else {
      setWarning(data['result_text']);
    }
  }

  return <div className='cash-out-pop-up'>
    <div className='cash-out-pop-up-container'>
      <div className='pop-up-header'>
        <span>{Utils.upperCase(t('cash-out'), context.language.get)}</span>
        <div className='pop-up-close' onClick={hideCashOutPopUp}/>
      </div>
      <div className='container'>
        <p className='total-cash-out'>{totalCashOut + ' ' + currency}</p>
        <div className="cash-out-button" onClick={sendCashOutRequest}>{Utils.upperCase(t('cash-out'), context.language.get)}</div>
        <div className='cash-out-button cancel' onClick={hideCashOutPopUp}>{Utils.upperCase(t('cancel'), context.language.get)}</div>
        {warning ? <p className='cash-out-warning'>{warning}</p> : null}
      </div>
    </div>
  </div>
}

export default memo(CashOutPopUp);